// @flow

export const PERMISSION_ACCESS_ORIGINALS = 'accessOriginals';
export const PERMISSION_ADD_ASSET = 'addAsset';
export const PERMISSION_DELETE_ASSET_CONTENTS = 'deleteAssetContents';
export const PERMISSION_DELETE_ASSET_FROM_CATALOG = 'deleteAssetFromCatalog';
export const PERMISSION_CAN_EMBED_METADATA = 'canEmbedMetadata';
export const PERMISSION_CAN_IMPORT_METADATA = 'canImportMetadata';
export const PERMISSION_CAN_MANAGE_PUBLIC_GALLERY = 'canManagePublicGallery';
export const PERMISSION_CAN_PUBLISH_NP_SITES = 'canPublishNetPublishSites';
export const PERMISSION_CAN_SMART_KEYWORD = 'canSmartKeyword';
export const PERMISSION_CREATE_CONTACT_SHEET = 'createContactSheet';
// export const PERMISSION_DOWNLOAD_PREVIEWS = 'downloadPreviews'; // not exposed in the UI
export const PERMISSION_MANAGE_FIELD_LISTS = 'canManageFieldLists';
export const PERMISSION_MODIFY_ASSET_CONTENTS = 'modifyAssetContents';
export const PERMISSION_MODIFY_ASSET_PROPERTIES = 'modifyAssetProperties';
export const PERMISSION_MODIFY_FOLDER_STRUCTURE = 'canModifyFolderStructure';
export const PERMISSION_MOVE_ASSETS = 'canMoveAssets';
export const PERMISSION_SAVE_OUTPUT_SETTING = 'saveOutputSetting';
export const PERMISSION_SYNC_AUTOSYNC_FOLDERS = 'synchronizeAutoSyncFolder';
export const PERMISSION_USE_CUSTOM_PRESETS = 'useCustomPresets';

export const allPermissions = [
  PERMISSION_ACCESS_ORIGINALS,
  PERMISSION_ADD_ASSET,
  PERMISSION_DELETE_ASSET_CONTENTS,
  PERMISSION_DELETE_ASSET_FROM_CATALOG,
  PERMISSION_CAN_EMBED_METADATA,
  PERMISSION_CAN_IMPORT_METADATA,
  PERMISSION_CAN_MANAGE_PUBLIC_GALLERY,
  PERMISSION_CAN_PUBLISH_NP_SITES,
  PERMISSION_CAN_SMART_KEYWORD,
  PERMISSION_CREATE_CONTACT_SHEET,
  PERMISSION_MANAGE_FIELD_LISTS,
  PERMISSION_MODIFY_ASSET_CONTENTS,
  PERMISSION_MODIFY_ASSET_PROPERTIES,
  PERMISSION_MODIFY_FOLDER_STRUCTURE,
  PERMISSION_MOVE_ASSETS,
  PERMISSION_SAVE_OUTPUT_SETTING,
  PERMISSION_SYNC_AUTOSYNC_FOLDERS,
  PERMISSION_USE_CUSTOM_PRESETS,
];

export const settableForReader = [
  PERMISSION_ACCESS_ORIGINALS,
  PERMISSION_CREATE_CONTACT_SHEET,
  PERMISSION_CAN_MANAGE_PUBLIC_GALLERY,
  PERMISSION_USE_CUSTOM_PRESETS,
];

export const unsettableForEditor = [
  PERMISSION_SAVE_OUTPUT_SETTING,
  PERMISSION_MODIFY_ASSET_CONTENTS,
  PERMISSION_CAN_PUBLISH_NP_SITES,
];

export const unsettableForPublisher = [
  PERMISSION_USE_CUSTOM_PRESETS,
  PERMISSION_ACCESS_ORIGINALS,
  PERMISSION_CAN_EMBED_METADATA,
  PERMISSION_CAN_MANAGE_PUBLIC_GALLERY,
  PERMISSION_CREATE_CONTACT_SHEET,
  PERMISSION_MODIFY_ASSET_CONTENTS,
];



// WEBPACK FOOTER //
// ./src/util/permissionUtils.js